<template>
  <div class="backdrop">
    <div class="close-floating" @click.prevent="closeOrderSystem"></div>
    <a href="#" class="close-button" @click.prevent="closeOrderSystem">
      <CloseSVG class />
    </a>
    <div class="powered-by">
      Powered by <a href="https://www.chatfood.io" target="_blank">ChatFood</a>
    </div>
  </div>
</template>

<script>
import CloseSVG from "@/assets/svgs/close.svg";
import PostMessages from "@/services/PostMessages";

export default {
  components: {
    CloseSVG
  },
  methods: {
    closeOrderSystem() {
      const messages = new PostMessages("closeOrderSystem");
      messages.send();
    }
  }
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: relative;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
}

.close-button {
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
  width: 1.2rem;

  svg {
    fill: #ffffff;
  }
}

.close-floating {
  position: fixed;
  width: calc(100vw - 500px);
  height: 100%;
  top: 0;
  left: 0;
}

.powered-by {
  position: absolute;
  font-size: 0.7rem;
  bottom: 0.8rem;
  left: 0.8rem;
  color: #ffffff;

  a {
    color: #058eff;
    text-decoration: underline;
  }
}

@media (max-width: 460px) {
  .backdrop {
    background-color: #ffffff;
    width: 100vw;
    height: 100vh;
  }

  .close-button {
    position: absolute;
    top: 0.4rem;
    left: 0.4rem;
    width: 1rem;
    color: #000000;

    svg {
      fill: #000000;
    }
  }
}
</style>
